module.exports = __webpack_public_path__ + "static/img/about3.d297c9ab.jpg";